<div class="row border rounded">
  <div>
    <div class="d-flex justify-content-between">

      <div class="col-lg-6">
        <div class="row row-cols-lg-auto g-2 align-items-center">
          <label class="col-form-label-sm">Loc:</label>
          <div class="col-12">
            <select name="locCodeTm" class="form-select form-select-sm select-m" [(ngModel)]="locCodeTm"
              (change)="onLocCodeTmChange($event)">
              <option *ngFor="let item of locList" value="{{item.value}}">{{item.text}}</option>
            </select>
          </div>
          <label class="col-form-label-sm">Date Range:</label>
          <div class="col-12">
            <input type="date" name="startDate" class="form-control form-control-sm date-input"
            [(ngModel)]="startDate" [ngModelOptions]="{standalone: true}" />
          </div>
          <div class="col-12">
            <input type="date" name="endDate" class="form-control form-control-sm date-input" [(ngModel)]="endDate" />
          </div>
          <div class="col-12">
            <button type="button" class="btn btn-sm btn-primary" (click)="initLoadData('clicked')"
              *ngIf="hasLoaded">Go</button>
            <button type="button" class="btn btn-sm btn-primary me-2" disabled *ngIf="!hasLoaded">
              <span class="spinner-border spinner-border-sm me-1"></span>
              <span>Loading...</span>
            </button>
          </div>
        </div>
        <!-- Buttons -->
        <div class="row row-cols-lg-auto g-2 p-2 align-items-center" *ngIf="hasLoaded">
          <div class="col-12">
            <button type="button" class="btn btn-sm btn-primary" (click)="clearFilters()">Clear Filters</button>
          </div>
          <div class="col-12">
            <button type="button" class="btn btn-sm btn-primary" (click)="resetSort()">Default Sort</button>
          </div>
          <div class="col-12">
            <button type="button" class="btn btn-sm btn-primary" (click)="exportExcel()">Export to Excel</button>
          </div>
        </div>
      </div>

      <div class="col-lg-6" *ngIf="hasLoaded">
        <div class="row row-cols-lg-auto g-2 align-items-center">
          <div class="col-12 d-flex align-items-center m-1">
            <button type="button" class="btn btn-light border border-primary btn-sm m-1 pa-btn">{{paCount}}
              P/A</button>
            <button type="button" class="btn btn-light border border-primary btn-sm m-1 dlvd-btn">{{dlvdCount}}
              Dlvd</button>
            <button type="button" class="btn btn-light border border-primary btn-sm m-1 fs-btn">{{fsCount}}
              F/S</button>
          </div>

          <div class="row row-cols-lg-auto g-2 p-2 align-items-center float-end ml-auto">
            <div class="fw-bold"
              *ngIf="filteredDataCount > 0 && filteredDataCount != totalCounter; else defaultLoadCount">
              {{filteredDataCount}} of {{totalCounter}} loads (filtered)
            </div>
            <ng-template #defaultLoadCount>
              <div class="fw-bold">{{totalCounter}} loads</div>
            </ng-template>
          </div>
        </div>

        <div class="row row-cols-lg-auto g-2 p-2 align-items-center">
          <div class="col align-items-center d-flex m-1" style="border: 1px solid #b0b3b6; height: 90%;">
            <label class="col-form-label-sm me-2">Toggle:</label>
            <button type="button" class="btn btn-light border m-2 border-primary btn-sm toggle-section"
              (click)="updatePA()">P/A</button>
            <button type="button" class="btn btn-light border m-2 border-primary btn-sm toggle-section"
              (click)="updateDlvd()">Dlvd</button>
            <button type="button" class="btn btn-light border m-2 border-primary btn-sm toggle-section"
              (click)="updateFS()">F/S</button>
          </div>


          <div class="col align-items-center d-flex m-1 p-1" style="border: 1px solid #b0b3b6; height: 100%;">
            <label class="col-form-label-sm me-2">Delivered Date:</label>
            <input type="date" name="deliveredDate" class="form-control form-control-sm date-input ms-2"
              [(ngModel)]="deliveredDate" [ngModelOptions]="{standalone: true}" />
            <button type="button" class="btn btn-sm btn-primary m-1" (click)="updateDeliveredDate()">Go</button>
          </div>
        </div>
      </div>
      <!-- E-Mail List To -->
      <!-- 
      <div class="col-auto">
        <div class="row row-cols-lg-auto g-2 align-items-center" *ngIf="hasLoaded">
          <div class="col-12 d-flex align-items-center m-1 email-container">
            <button (click)="toggleTextarea()" class="btn btn-sm btn-primary">E-Mail List To
              <span>{{ !isTextareaVisible ? '>>' : '<<' }}</span>
            </button>
            <form #emailForm="ngForm" (ngSubmit)="onSubmit(emailForm)">
              <div>
                <textarea *ngIf="isTextareaVisible" name="emailContent" [(ngModel)]="emailContent"
                  class="email-textarea row" required #emailContentRef="ngModel" [@smoothExpand]
                  style="background-color: #FFF2CC;">
      </textarea>
                <span *ngIf="isTextareaVisible" class="ms-2"><i>Separate addresses with a semicolon</i></span>
              </div>
              <button [disabled]="emailForm.invalid" class="btn btn-sm btn-primary m-2" *ngIf="isTextareaVisible">Send
                e-mail</button>
            </form>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</div>

<tm-loads [ticketMaintenanceParameters]="ticketMaintenanceParameters" #tmLoads [loads]="loads"
  (updateTotalCounterEmit)="updateTotalCounter($event)" (filteredDataEmit)="updateFSPADlvdCount($event, true)">
</tm-loads>